import styled from '@emotion/styled';
import { Trans, useTranslation } from 'react-i18next';
import { useSiteName } from '@hotjar/site';
import { Code } from '@hotjar/webapp/components/Code';
import { CodeBlock, Text, tokens } from '@hotjar/hotsauce';
import type { Site } from '@hotjar/site';
import { getDemoPlaceholder, getTrackingCode } from '../TrackingCodeSnippet/trackingCode';

const StyledCode = styled(Code)`
  background-color: ${tokens.color.dusk_400};
  color: ${tokens.color.text_light};
`;

const HeadTag = () => <StyledCode>&lt;head&gt;</StyledCode>;

export const NewTrackingCodeSnippet = ({
  showDemoPlaceholder,
  site,
  newColorScheme,
}: {
  showDemoPlaceholder?: boolean;
  site: Site;
  newColorScheme?: boolean;
}): JSX.Element => {
  const { t } = useTranslation();
  const siteName = useSiteName(site);

  return (
    <div data-testid="new-tracking-code-snippet">
      <Text
        style={{ marginBottom: tokens.spacer.x3 }}
        textType="body2"
        textColor="text_default"
        as="p"
      >
        <Trans i18nKey="activation:setup-wizard.main-page.hero.description-manual-simplify-setup-experiment">
          Paste this code into the <HeadTag /> of every page where you want to track user behavior
          or collect feedback.
        </Trans>
      </Text>
      <CodeBlock
        copyText={t('activation:tracking-code.installation.copy-btn-text')}
        copyFeedback={t('activation:tracking-code.installation.copy-btn-feedback')}
        content={
          showDemoPlaceholder ? getDemoPlaceholder(siteName) : getTrackingCode(siteName, site.id)
        }
        allowCopy
        css={
          newColorScheme
            ? {
                backgroundColor: tokens.color.ui_background,
                button: { backgroundColor: tokens.color.ui_background },
                div: { backgroundColor: tokens.color.cobalt_200 },
              }
            : ''
        }
      />
    </div>
  );
};
